(ns ncr.fragment.label
  (:require
   [clojure.string :as str]
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.me :as me]
   [ncr.etc.util :as u]
   [ncr.widgets.pf :as wpf]
   [ncr.etc.pf :as pf]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.modal :as m]
   [ncr.etc.alert :as a]
   [ncr.backend :as b]
   [goog.object :as gob]))

(def ^:private recent-labels-count 3)
(def ^:private recent-labels-pref-key "neckar.labels.recent")

(defn- read-recent-labels-pref []
  (filter seq
    (-> recent-labels-pref-key
      js/localStorage.getItem
      (or "")
      (str/split #","))))

(defn- write-recent-labels-pref [recent-labels]
  (js/localStorage.setItem recent-labels-pref-key (str/join "," recent-labels)))

(defn c-labels-selector
  [{:keys [focus-input? form id menu-append-to dropup?]
    :or {focus-input? false}
    :as props}
   labels]
  (let
    [by-id (u/index-by :id labels)
     on-empty-enter (get props :on-empty-enter)

     me (uix/context me/*context*)

     recent-label-by-id
     (fn [id]
       (-> me
         (me/label-by-id id)
         (select-keys [:id :name])))

     recent-labels
     (uix/state
       (->> (read-recent-labels-pref)
         (map recent-label-by-id)
         (filter seq)))

     field-name (:name props)]

    [rhf/c-controller
     {:name field-name
      :control (:control form)
      :render
      (fn [props]
        (let
          [selections (into #{} (get-in props [:field :value]))
           {:keys [get-values set-value]} form]
          [:<>
           [wpf/c-pf-select
            (merge
              {:class :nrc-label-select
               :toggle-id id
               :variant :typeaheadmulti
               :focus-input? focus-input?
               :label-fn :name
               :selections
               (->> selections
                 (select-keys by-id)
                 (vals))
               :max-height "200px"
               :on-empty-enter on-empty-enter

               :on-select
               (fn [_ {:keys [id]} _]
                 (let
                   [update (-> props :field :on-change)
                    removed? (contains? selections id)]
                   (update
                     (clj->js
                       (if removed?
                         (disj selections id)
                         (conj selections id))))
                   (when-not removed?
                     (let
                       [cur-recent-labels @recent-labels
                        new-recent-labels
                        (->> cur-recent-labels
                          (filter #(not= id (:id %)))
                          (cons (recent-label-by-id id))
                          (take recent-labels-count))]
                       (reset! recent-labels new-recent-labels)
                       (write-recent-labels-pref (map :id new-recent-labels))))))}
              (when menu-append-to
                {:menu-append-to menu-append-to})
              (when dropup?
                {:direction :up}))
            (sort-by :name labels)]
           [pf/c-chip-group {:class :ncr-recent}
            (for [{:keys [id] :as rl} @recent-labels]
              ^{:key id}
              [pf/c-chip
               {:is-overflow-chip true
                :component "button"
                :on-click
                (fn [_]
                  (let
                    [recent-label-ids
                     (set
                       (or
                         (gob/get (get-values) (name field-name))
                         (array)))]
                    (set-value field-name
                      (clj->js
                        (if (contains? recent-label-ids id)
                          (disj recent-label-ids id)
                          (conj recent-label-ids id)))
                      {:shouldDirty true :shouldTouch true})))}
               (:name rl)])]]))}]))

(defn- c-labels-dialog [fragments]
  (let
    [singleton (u/singleton fragments)
     modal-id :select-labels-modal
     ref (uix/ref)

     form
     (rhf/use-form
       {:should-focus-error false
        :default-values
        {:labels
         (if-let [{:keys [labels]} singleton]
           (set labels)
           #{})}})]

    (m/use-submit-form modal-id ref
      (rhf/modal-submit form assoc :mode (if (some? singleton) :set :add)))

    [m/c-modal
     {:title "Set Labels"
      :variant :small
      :id modal-id
      :ref ref
      :is-overflow-visible true
      :actions
      (conj
        (if (some? singleton)
          [[pf/c-button
            {:variant :primary
             :on-click (rhf/modal-submit form assoc :mode :set)}
            "Ok"]]

          [[pf/c-button
            {:variant :primary
             :on-click (rhf/modal-submit form assoc :mode :add)}
            "Add"]

           [pf/c-button
            {:variant :secondary
             :on-click (rhf/modal-submit form assoc :mode :remove)}
            "Remove"]

           [pf/c-button
            {:variant :secondary
             :is-danger true
             :on-click (rhf/modal-submit form assoc :mode :set)}
            "Overwrite"]])
        [pf/c-button
         {:variant :link :on-click #(m/close! nil)}
         "Cancel"])}
     [pf/c-form {:on-submit #(.preventDefault %)}
      [pf/c-form-group
       {:style {:min-height 275}}
       [c-labels-selector
        {:name :labels
         :form form
         :on-empty-enter (rhf/modal-submit form assoc :mode :add)
         :focus-input? true}
        (get-in (uix/context me/*context*) [:cluster :labels])]]]]))

(defn- !labels-operation [op fragments labels]
  (b/!multi-mutation
    (map
      (fn [{:keys [id]}]
        [id
         [:reference_edit_labels
          {:id id :op op :labels (into [] labels)}]])
      fragments)))

(defn !apply-labels [fragments payload]
  (go
    (match payload
      {:mode :add :labels labels}
      (<!
        (a/!fragment-operation
          {:operation-title "Adding Labels"
           :success-title "Labels Added"
           :fragments fragments}
          (!labels-operation :add fragments labels)))

      {:mode :remove :labels labels}
      (<!
        (a/!fragment-operation
          {:operation-title "Removing Labels"
           :success-title "Labels Removed"
           :fragments fragments}
          (!labels-operation :remove fragments labels)))

      {:mode :set :labels labels}
      (<!
        (a/!fragment-operation
          {:operation-title "Setting Labels"
           :success-title "Labels Set"
           :fragments fragments}
          (!labels-operation :set fragments labels)))
      nil
      [:error :cancel])))

(defn !edit-labels [_me fragments]
  (go
    (<!
      (!apply-labels fragments (<! (m/!modal #'c-labels-dialog fragments))))))
